import { render, staticRenderFns } from "./DeleteStockSale.vue?vue&type=template&id=99904160&"
import script from "./DeleteStockSale.vue?vue&type=script&lang=js&"
export * from "./DeleteStockSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports